import useModal from "../../../useModal";
import UseContext from "../../../../../hooks/useContext";
import Modalheader from "../../../components/header";
import React, { useEffect, useMemo, useState } from "react";
import ModalFooter from "../../../components/footer";
import Button from "../../../../button";
import ModalBody from "../../../components/body";
import StyledInput from "../../../../styledInput/StyledInput";
import { EMAIL_REGEX, NAME_REGEX } from "../../../../../helper/helper";
import ApiDatabase from "../../../../../server";
import { toast } from "react-toastify";

const COMPANY_ROLE_OPTIONS = [
  { value: "200", label: "Observateur" },
  { value: "205", label: "Manageur" },
  { value: "210", label: "Responsable" },
  { value: "215", label: "Directeur" },
  { value: "220", label: "Superviseur" },
  { value: "225", label: "Administrateur" },
];

const getRoleDescription = (roleValue) => {
  const role = Number(roleValue);
  if (role === 200) {
    return "L’observateur peut uniquement consulter l’ensemble des factures, relevés d’heures, contrats et missions crées par l’entreprise.";
  }
  if (role === 205) {
    return "Le manageur peut uniquement vérifier des relevés d’heures.";
  }
  if (role === 210) {
    return "Le responsable peut signer des contrats, importer des factures, vérifier des relevés d’heures, et créer des missions.";
  }
  if (role === 215) {
    return "Le directeur peut signer des contrats, importer des factures, vérifier des relevés d’heures, et créer des missions et modifier le profil de l’entreprise.";
  }
  if (role === 220) {
    return "Le superviseur peut créer des missions et vérifier des relevés d'heures.";
  }
  return "";
};

const ModalEditCompanyMember = () => {
  const { toggle } = useModal();
  const { modalData, setModalDataReturn } = UseContext();
  const token = localStorage.getItem("xsrfToken");
  const [isWaiting, setIsWaiting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [role, setRole] = useState("");
  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    role: "",
  });

  const isAdminTakenByOther = useMemo(() => {
    const employees = modalData.employees ?? [];
    const adminEmployee = employees.find(
      (employee) => Number(employee.role) === 225
    );
    if (!adminEmployee) return false;
    return adminEmployee.user?._id !== modalData.idEmployee;
  }, [modalData.employees, modalData.idEmployee]);

  useEffect(() => {
    if (modalData.idCompany && modalData.idEmployee) {
      setIsWaiting(true);
      ApiDatabase.getCompanyEmployee(
        { token, idCompany: modalData.idCompany, idEmployee: modalData.idEmployee },
        (data) => {
          if (data.employee) {
            setFirstName(data.employee.firstname ?? "");
            setLastName(data.employee.lastname ?? "");
            setEmail(data.employee.email ?? "");
            if (data.employee.role != null) {
              setRole(String(data.employee.role));
            }
          }
          setIsWaiting(false);
        },
        (err) => {
          console.log(err);
          setIsWaiting(false);
        }
      );
    }
  }, [modalData.idCompany, modalData.idEmployee, token]);

  useEffect(() => {
    const newErrors = {
      firstName: firstName
        ? NAME_REGEX.test(firstName)
          ? ""
          : "Prénom invalide."
        : "",
      lastName: lastName
        ? NAME_REGEX.test(lastName)
          ? ""
          : "Nom invalide."
        : "",
      email: email ? (EMAIL_REGEX.test(email) ? "" : "Email invalide.") : "",
      role: "",
    };

    setErrors(newErrors);
  }, [firstName, lastName, email, role]);

  const handleSubmit = () => {
    if (!errors.firstName && !errors.lastName && !errors.email && !errors.role) {
      if (!firstName) {
        setErrors((prevData) => ({
          ...prevData,
          firstName: "Le champs est requis.",
        }));
      }
      if (!lastName) {
        setErrors((prevData) => ({
          ...prevData,
          lastName: "Le champs est requis.",
        }));
      }
      if (!email) {
        setErrors((prevData) => ({
          ...prevData,
          email: "Le champs est requis.",
        }));
      }
      if (!role) {
        setErrors((prevData) => ({
          ...prevData,
          role: "Le champs est requis.",
        }));
      }

      if (
        !errors.firstName &&
        !errors.lastName &&
        !errors.email &&
        !errors.role &&
        firstName &&
        lastName &&
        email &&
        role
      ) {
        setIsLoading(true);
        ApiDatabase.postEditCompanyMember(
          {
            token,
            idCompany: modalData.idCompany,
            idEmployee: modalData.idEmployee,
            employee: {
              firstName,
              lastName,
              email,
              role: Number(role),
            },
          },
          (data) => {
            if (data.employee) {
              toast.success("Le compte employé a bien été modifié.");
              setModalDataReturn({ type: "employee_edited", user: data.employee });
              toggle();
              setIsLoading(false);
            }
          },
          (err) => {
            console.log(err);
            toast.error(
              "Une erreur est survenue, veuillez réessayer ou contacter le support"
            );
            setIsLoading(false);
          }
        );
      }
    }
  };

  const roleDescription = getRoleDescription(role);

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Modifier un membre
      </Modalheader>
      <ModalBody>
        {isWaiting ? (
          <div className={"flex flex-col gap-6 animate-pulse"}>
            <div className={"h-16 bg-gray-200 rounded w-full"}></div>
            <div className={"flex gap-6"}>
              <div className={"h-16 bg-gray-200 rounded w-full"}></div>
              <div className={"h-16 bg-gray-200 rounded w-full"}></div>
            </div>
            <div className={"h-16 bg-gray-200 rounded w-full"}></div>
          </div>
        ) : (
          <div className={"flex flex-col gap-6 text-sm"}>
            <StyledInput
              label={"E-mail"}
              type={"email"}
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              error={errors.email}
            />
            <div className={"flex gap-6 w-full"}>
              <div className={"w-full"}>
                <StyledInput
                  label={"Prénom"}
                  type={"text"}
                  value={firstName}
                  onChange={(e) => {
                    setFirstName(e.target.value);
                  }}
                  error={errors.firstName}
                />
              </div>
              <div className={"w-full"}>
                <StyledInput
                  label={"Nom"}
                  type={"text"}
                  value={lastName}
                  onChange={(e) => {
                    setLastName(e.target.value);
                  }}
                  error={errors.lastName}
                />
              </div>
            </div>
            <div className={"flex flex-col gap-1"}>
              <label htmlFor="company-member-role" className={"ft-sm text-gray-500"}>
                Rôle
              </label>
              <select
                id="company-member-role"
                value={role}
                onChange={(e) => setRole(e.target.value)}
                className={
                  "w-full h-10 border rounded-md px-2 ft-sm text-gray-900 focus:border-yellow-500 focus:outline-none"
                }
              >
                <option value="" disabled>
                  Sélectionner un rôle
                </option>
                {COMPANY_ROLE_OPTIONS.map((option) => (
                  <option
                    key={option.value}
                    value={option.value}
                    disabled={
                      option.value === "225" &&
                      isAdminTakenByOther &&
                      role !== "225"
                    }
                  >
                    {option.label}
                  </option>
                ))}
              </select>
              {errors.role && (
                <div className={"text-red-500 flex items-center gap-1 text-xs"}>
                  {errors.role}
                </div>
              )}
              {roleDescription && (
                <div className={"text-gray-500 ft-sm mt-2"}>{roleDescription}</div>
              )}
            </div>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        {isLoading ? (
          <>
            <Button size={"LG"} color={"SECONDARY"}>
              Fermer
            </Button>
            <Button size={"LG"} color={"DISABLED"}>
              Confirmation ...
            </Button>
          </>
        ) : (
          <>
            <Button size={"LG"} color={"SECONDARY"} onClick={toggle}>
              Fermer
            </Button>
            <Button size={"LG"} color={"PRIMARY"} onClick={handleSubmit}>
              Confirmer
            </Button>
          </>
        )}
      </ModalFooter>
    </>
  );
};

export default ModalEditCompanyMember;
